export interface TableMenuActionChange {
  type: 'FilterClear' | 'TableSetting' | 'Download';
  data?: any;
}
